import Component from "vue-class-component";
import Vue from "vue";
import descr from "@/components/describe.vue";

@Component({ components: { descr, describe:descr } })
export default class Style extends Vue {

}